import { gql } from 'apollo-angular';

export const login_admin = gql`
  mutation User($input: LoginInputSchema!) {
    auth_admin(input: $input)
  }
`;

export const generate_otp_with_email = gql`
  mutation User($email: String!) {
    generateOtpWithEmail(email: $email, type: "forget", is_for_admin: true)
  }
`;

export const validate_otp = gql`
  mutation User($input: OtpValidateSchema!) {
    validateOtp(input: $input)
  }
`;

export const reset_password = gql`
  mutation User($password: String!) {
    resetPassword(password: $password)
  }
`;
